import React, { FC, useContext, useRef, useEffect } from 'react';
import { toast } from 'react-toastify';
import Clipboard from 'clipboard';
import Tooltip from 'react-tooltip';
import { FormattedMessage } from 'react-intl';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../modal/components/modal-restricted/withRestrictedModal';
import { UserContext } from '../../../user/UserContext';

type Props = {
  text: string;
  source: string;
  sendAnalytics: () => void;
} & WithRestrictedModalProps;

export const RawShareActionButton: FC<Props> = ({
  sendAnalytics,
  source,
  text,
  openRestrictedModal,
}) => {
  const { accessPremium } = useContext(UserContext);

  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!accessPremium) return;
    if (!buttonRef || !buttonRef.current) return;
    const clipboard = new Clipboard(buttonRef.current, {
      text: () => text,
    });
    return () => {
      clipboard.destroy();
    };
  }, []);

  const copyAndConfirm = () => {
    toast(
      <p>
        <FormattedMessage id="components/sub-header/actions/ShareActionButton.tsx/1" />
      </p>,
    );
    sendAnalytics();
  };

  const canUserCopy = accessPremium
    ? copyAndConfirm
    : () => openRestrictedModal(`${source}_share`);

  return (
    <>
      <button
        data-multiline="true"
        data-tip="Copier la référence et le lien public"
        data-for="copy-reference-tooltip"
        data-place="bottom"
        data-effect="solid"
        data-delay-show="250"
        data-delay-hide="100"
        data-class="copy-button__tooltip"
        type="button"
        className="button clear"
        onClick={canUserCopy}
        ref={buttonRef}
      >
        <i className="material-icons icons__link" />
        <span>
          {' '}
          <FormattedMessage id="components/sub-header/actions/ShareActionButton.tsx/2" />
        </span>
      </button>

      <Tooltip id="copy-reference-tooltip" />
    </>
  );
};

export const ShareActionButton = withRestrictedModal(RawShareActionButton);
